import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import Header from "components/VerticalLayout/Header";
import Column from "antd/es/table/Column";

// Options
const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Foreman", value: "Foreman" },
];

const monthOptions = [
  { label: "Apr-2025", value: "Apr-2025" },
  { label: "May-2025", value: "May-2025" },
  // Add more months as needed
];

// Dummy Data
const data = [
  { sno: 1, empNo: "0", name: "AES ADMIN", dob: "03.04.24", doj: "03.04.24", address: "General admin", empCategory: "Admin", designation: "General Admin", fatherName: "", entryDate: "03.04.24", days: Array(30).fill("P"), wd: "30.0", lw: "", lop: "", nfh: "1", wh: "0" },
  { sno: 2, empNo: "001", name: "ARUN", dob: "13.06.89", doj: "01.01.24", address: "", empCategory: "Staff", designation: "Office Assistant", fatherName: "Vijay", entryDate: "01.01.24", days: Array(30).fill("P"), wd: "26.0", lw: "", lop: "", nfh: "1", wh: "4" },
];

// Column Definitions
const columns = [
  { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center" },
  { Header: "Emp No", accessor: "empNo" },
  { Header: "Name of the Workman", accessor: "name" },
  { Header: "DOB", accessor: "dob" },
  { Header: "DOJ", accessor: "doj" },
  { Header: "Address", accessor: "address" },
  { Header: "EmpCategory", accessor: "empCategory" },
  { Header: "Designation", accessor: "designation" },
  { Header: "Father / Husband Name", accessor: "fatherName" },
  { Header: "Date of Entry in to Service", accessor: "entryDate" },
  // Add day columns 1 to 30
  ...Array.from({ length: 30 }, (_, i) => ({
    Header: (i + 1).toString(),
    accessor: `day${i + 1}`,
  })),
  { Header: "WD", accessor: "wd" },
  { Header: "LW", accessor: "lw" },
  { Header: "LOP", accessor: "lop" },
  { Header: "NFH", accessor: "nfh" },
  { Header: "WH", accessor: "wh" },
];

// New table data and columns (data2 and columns2)
const data2 = [
  { sno: 1, empNo: "00585", name: "JAANU", age: "24", sex: "F", permenantaddress: "17,street,coimbatore-655256", localaddress: "17,street,coimbatore-655256", empCategory: "Manager", designation: "Apprentice", fatherName: "test", entryDate: "09.10.24", wageRate: "17000.00", signature1: "", terminationDate1: "", contractorSignature1: "", days: [...Array(30)].fill("X"), wd: "26.0" },
  { sno: 2, empNo: "006", name: "REVATHY", age: "30", sex: "F", permenantaddress: "45, Lane 2, Chennai", localaddress: "45, Lane 2, Chennai", empCategory: "Staff", designation: "Engineer", fatherName: "Kumar", entryDate: "12.03.24", wageRate: "18000.00", signature1: "", terminationDate1: "", contractorSignature1: "", days: [...Array(30)].fill("P"), wd: "28.0" },
  { sno: 3, empNo: "007", name: "REKHA", age: "27", sex: "F", permenantaddress: "12, Park Street, Chennai", localaddress: "12, Park Street, Chennai", empCategory: "Staff", designation: "Technician", fatherName: "Suresh", entryDate: "01.02.24", wageRate: "19000.00", signature1: "", terminationDate1: "", contractorSignature1: "", days: [...Array(30)].fill("W"), wd: "25.0" },
  { sno: 4, empNo: "008", name: "MALLIKA", age: "29", sex: "F", permenantaddress: "23, Green Road, Chennai", localaddress: "23, Green Road, Chennai", empCategory: "Staff", designation: "Supervisor", fatherName: "Ramesh", entryDate: "15.01.24", wageRate: "20000.00", signature1: "", terminationDate1: "", contractorSignature1: "", days: [...Array(30)].fill("X"), wd: "30.0" },
  { sno: 5, empNo: "009", name: "MAHALINGAM", age: "35", sex: "M", permenantaddress: "67, Main Road, Chennai", localaddress: "67, Main Road, Chennai", empCategory: "Manager", designation: "Senior Manager", fatherName: "Vijay", entryDate: "10.01.24", wageRate: "25000.00", signature1: "", terminationDate1: "", contractorSignature1: "", days: [...Array(30)].fill("P"), wd: "29.0" },
  { sno: 6, empNo: "010", name: "GOWRI", age: "32", sex: "F", permenantaddress: "89, Blue Street, Chennai", localaddress: "89, Blue Street, Chennai", empCategory: "Staff", designation: "Assistant", fatherName: "Arun", entryDate: "05.02.24", wageRate: "22000.00", signature1: "", terminationDate1: "", contractorSignature1: "", days: [...Array(30)].fill("P"), wd: "27.0" },
];


const columns2 = [
  {
    Header: "Name and Address of Principal Employer :",
    columns: [
      {
        Header: "Name and Location Of the work site :", columns: [
          { Header: "S No", Cell: ({ row }) => data.length - row.index + 4, className: "serial-no text-center" },
          { Header: "Emp No", accessor: "empNo" },
          { Header: "Emp Category", accessor: "empCategory" },
          { Header: "Designation", accessor: "designation" },
        ]
      }
    ]
  },
  {
    Header: "AES Technologies India Private Limited", columns: [
      {
        Header: "Unit 1", columns: [
          { Header: "Name of the Workman", accessor: "name" },
          { Header: "Age", accessor: "age" },
          { Header: "Sex", accessor: "sex" },
          { Header: "Permanent Home Address", accessor: "permenantaddress" },
        ]
      }
    ]
  },
  {
    Header: "Name and Address of Contractor :", columns: [
      { Header: "Local Address", accessor: "localaddress" },
      { Header: "Father / Husband Name", accessor: "fatherName" },
      { Header: "Date of Entry in Service", accessor: "entryDate" },
      { Header: "Rate of Wages", accessor: "wageRate" },
      // Dynamically add day columns 1-30
      ...Array.from({ length: 30 }, (_, i) => ({
        Header: `${i + 1}`,
        accessor: `day${i + 1}`,
      })),
      { Header: "No. of days Worked", accessor: "wd" },
      { Header: "Signature / Thumb Impression", accessor: "signature" },

    ]
  },
  {
    Header: "Month:", columns: [
      {
        Header: "Year", columns: [
          { Header: "Date of Termination", accessor: "terminationDate" },
        ]
      }
    ]
  },
  {
    Header: "May", columns: [
      {
        Header: "2025", columns: [
          { Header: "Signature of Contractor / Representative", accessor: "contractorSignature" },
        ]
      },
    ]
  }
];


const AttendanceReportForm25_26 = () => {
  const formik = useFormik({
    initialValues: {
      category: null,
      month: monthOptions[0], // Default to Apr-2025
      formType: "Form 12 & 25", // Default to Form 12 & 25
    },
    validationSchema: Yup.object({
      month: Yup.object({
        value: Yup.string().required("Month is required")
      }).nullable().required("Month is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="FORM 25 & 26" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3 align-items-end">
                <Col md={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Month <span className="text-danger">*</span></Label>
                  <CustomSelect
                    name="month"
                    value={formik.values.month}
                    onChange={(val) => formik.setFieldValue("month", val)}
                    options={monthOptions}
                    placeholder="--Select--"
                  />
                  {formik.touched.month && formik.errors.month ? (
                    <div className="text-danger">{formik.errors.month}</div>
                  ) : null}
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <Label className=" gap-2"><input type="radio" name="formType" checked={formik.values.formType === "Form 26"} onChange={() => formik.setFieldValue("formType", "Form 26")} /> Form 26</Label>
                  <Label className="ms-3 gap-2"><input type="radio" name="formType" checked={formik.values.formType === "Form 12 & 25"} onChange={() => formik.setFieldValue("formType", "Form 12 & 25")} /> Form 12 & 25</Label>
                </Col>
                <Col md={12} className="d-flex align-items-end justify-content-end gap-2 flex-wrap">
                  <Button type="submit" className="btn button-search"><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" className="btn button-print"><i className="fas fa-print me-1" /> Print</Button>
                  <Button type="button" className="btn button-export"><i className="fas fa-file-export me-1" /> Export</Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
        {formik.values.formType === "Form 26" ? (
          <Card>
            <CardBody>
              <h5 className="text-primary">FORM No. XXVI</h5>
              <div className="p-2 mb-0 timesheet-summary hoursheet text-center table-bordered "><p className="mb-0"><strong>REGISTER OF EMPLOYMENT OF CONTRACT LABOUR (See Rule 75)</strong></p></div>
              <TableContainer
                columns={columns2}
                data={data2.map(row => ({
                  ...row,
                  ...row.days.reduce((acc, val, i) => ({ ...acc, [`day${i + 1}`]: val }), {})
                }))}
                isGlobalFilter={false}
                customPageSize={10}
                tableSorter={false}
              />
            </CardBody>
          </Card>
        ) : (
          <Card>
            <CardBody>
              <div className="timesheet-summary hoursheet p-2 mb-0 d-flex align-items-center justify-content-between flex-wrap">
                <div><p className="mb-0"><strong>AES Technologies India Private Limited- Unit 1</strong></p></div>
                <div><p className="mb-0"><strong>28.05.25</strong></p></div>
              </div>
              <div className="p-2 mb-0 timesheet-summary hoursheet text-center table-bordered table-head border-white border-top-0"><p className="mb-0"><strong>FORM No. 12 & 25 & FORM VI UNDER TN NFH RULES 1959</strong></p></div>
              <div className="p-2 mb-0 timesheet-summary hoursheet text-center table-bordered table-head"><p className="mb-0"><strong>PRESCRIBED UNDER RULE 80 & 103</strong></p></div>
              <TableContainer
                columns={columns}
                data={data.map(row => ({
                  ...row,
                  ...row.days.reduce((acc, val, i) => ({ ...acc, [`day${i + 1}`]: val }), {})
                }))}
                isGlobalFilter={false}
                customPageSize={10}
                tableSorter={false}
              />
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
};

export default AttendanceReportForm25_26;
